import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"
import { FavoriteList, OptimizedFavoriteListDetails } from "./types"

export interface GetUserFavoriteList {
  favoriteListId: string
}

export interface GetUserFavListRequest extends Partial<AxiosRequestConfig> {
  params: GetUserFavoriteList
}

export interface FavouritesListItemSearchResponseData extends ResponseData {
  data: FavoriteList
}
export interface FavouritesListItemSearchResponse extends AxiosResponse {
  data: FavouritesListItemSearchResponseData
}

// old API instead use getSpecificFavoriteListWithIdApiOptimized
export function getSpecificFavoriteListWithIdApi(
  {
    params,
    method = "get",
    url = `/user/favouritelist/propertyfavouritelist/${params.favoriteListId}`,
    ...config
  }: GetUserFavListRequest,
  axiosInstance: AxiosInstance,
): Promise<FavouritesListItemSearchResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<FavouritesListItemSearchResponse>
}

export interface OptimizedFavouritesListItemSearchResponseData
  extends ResponseData {
  data: OptimizedFavoriteListDetails
}
export interface OptimizedFavouritesListItemSearchResponse
  extends AxiosResponse {
  data: OptimizedFavouritesListItemSearchResponseData
}

export function getSpecificFavoriteListWithIdOptimizedApi(
  {
    params,
    method = "get",
    url = `/user/favouritelist/all-properties/${params.favoriteListId}`,
    ...config
  }: GetUserFavListRequest,
  axiosInstance: AxiosInstance,
): Promise<OptimizedFavouritesListItemSearchResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<OptimizedFavouritesListItemSearchResponse>
}
